import { CpCommerceConstants } from '../../sdk';
import * as fromDatatype from '../datatype-library/index';
import { ShippingConfigJsonTypeInterface } from './shipping_config_json.model';

// linking to other database table.

export interface bl_cms_app_version_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  website_guid: fromDatatype.GuidDataFieldInterface;
  device_platform: fromDatatype.VarcharDatatypeInterface;
  app_version: fromDatatype.VarcharDatatypeInterface;
  release_date: fromDatatype.TimestampTzDatatypeInterface;
  is_mandatory: boolean;
  description: fromDatatype.TextDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  property_json: any;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_cms_app_version_hdr_RowClass
  implements bl_cms_app_version_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    website_guid: fromDatatype.GuidDataFieldInterface;
    device_platform: fromDatatype.VarcharDatatypeInterface;
    app_version: fromDatatype.VarcharDatatypeInterface;
    release_date: fromDatatype.TimestampTzDatatypeInterface;
    is_mandatory: boolean;
    description: fromDatatype.TextDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    property_json: any;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
  }
